import { inherits as _inherits, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ModalBody } from 'carbon-components-react';
import { FW_PREFIX } from '../../../shared/constants/generalConstants.js';

var _excluded = ["modalBodyV2ClassName", "dialogBody"];
var IlModalBodyV2 = /*#__PURE__*/function (_Component) {
  function IlModalBodyV2() {
    _classCallCheck(this, IlModalBodyV2);
    return _callSuper(this, IlModalBodyV2, arguments);
  }
  _inherits(IlModalBodyV2, _Component);
  return _createClass(IlModalBodyV2, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        modalBodyV2ClassName = _this$props.modalBodyV2ClassName,
        dialogBody = _this$props.dialogBody,
        rest = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React__default.createElement(ModalBody, _extends({}, rest, {
        className: classNames("".concat(modalBodyV2ClassName), "".concat(FW_PREFIX, "__IlModalBodyV2"))
      }), dialogBody);
    }
  }]);
}(Component);
IlModalBodyV2.propTypes = {
  modalBodyV2ClassName: PropTypes.string,
  dialogBody: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export { IlModalBodyV2 };
